module.exports = __webpack_public_path__ + "img/Distinguished Master Guardian.52935a7b.png";